<app-breadcrumb [home]="home" [items]="breadcrumbs" />

<header class="contract-page__header">
  <div class="contract-page__heading">
    <h1>Modelos de contrato de cliente</h1>
    @if (current(); as template) {
      <p class="contract-page__meta">
        <span class="contract-page__chip">Versão vigente v{{ template.version }}</span>
        Salva em {{ template.createdAt | vaultDateTime }}
        @if (template.createdByName) {
          por {{ template.createdByName }}
        }
      </p>
    }
  </div>

  <div class="contract-page__actions">
    <app-button
      [label]="historyOpen() ? 'Ocultar histórico' : 'Histórico'"
      icon="pi pi-history"
      theme="white"
      (sendButtonClick)="toggleHistory()" />
    @if (!readOnly()) {
      <app-button
        label="Salvar nova versão"
        icon="pi pi-check"
        title="Salvar nova versão (Ctrl+S)"
        [isLoading]="saving()"
        loadingText="Salvando..."
        [disabled]="!canSave()"
        (sendButtonClick)="save()" />
    }
  </div>
</header>

<!-- Um modelo por tipo; a aba fica na URL (`?type=ga`). -->
<div class="contract-template__tabs" role="tablist" aria-label="Tipo de contrato do modelo">
  @for (item of types; track item) {
    <button
      type="button"
      role="tab"
      class="contract-template__tab"
      [class.contract-template__tab--active]="type() === item"
      [attr.aria-selected]="type() === item"
      (click)="selectType(item)">
      <i [class]="item === 'FlatFee' ? 'pi pi-percentage' : 'pi pi-chart-line'"></i>
      {{ typeLabel(item) }}
    </button>
  }
</div>

@if (loading()) {
  <app-loading />
} @else {
  <div class="contract-page__layout" [class.contract-page__layout--with-aside]="historyOpen()">
    <section class="contract-page__main">
      @if (readOnly()) {
        <div class="contract-page__notice contract-page__notice--warn" role="status">
          <i class="pi pi-lock"></i>
          <span>{{ textLockedMessage }}</span>
        </div>
      }

      <div class="contract-page__notice contract-page__notice--info" role="note">
        <i class="pi pi-info-circle"></i>
        <span>
          Use o botão <strong>Variável</strong> para inserir dados que mudam por contrato (dados da
          empresa e valores). Eles aparecem como <code>{{ variableExample }}</code> e são
          preenchidos quando o contrato é gerado e a cada gravação.
          @if (type() === 'ActiveManagement') {
            As cláusulas opcionais ficam entre marcadores de bloco, como
            <code>{{ blockExample }}</code
            >: só entram no contrato com o bloco ligado. Não apague os marcadores.
          }
        </span>
      </div>

      @if (viewing(); as old) {
        <div class="contract-page__notice contract-page__notice--warn" role="status">
          <i class="pi pi-eye"></i>
          <span>
            Você está vendo a <strong>versão {{ old.version }}</strong
            >, salva em {{ old.createdAt | vaultDateTime }}. Ela é só para leitura.
          </span>
          <div class="contract-page__notice-actions">
            <app-button
              label="Voltar para a vigente"
              theme="white"
              size="small"
              (sendButtonClick)="closeViewing()" />
            @if (!readOnly()) {
              <app-button
                label="Usar como base"
                icon="pi pi-copy"
                size="small"
                (sendButtonClick)="useViewingAsBase()" />
            }
          </div>
        </div>

        <app-rich-text-editor [formControl]="viewingBodyControl" [readonly]="true" />
      }

      <!-- O editor da versão em edição fica montado (só escondido) enquanto uma versão antiga é
           lida, para não perder o desfazer nem o texto em andamento. -->
      <div [class.contract-page__hidden]="!!viewing()">
        @if (!readOnly()) {
          <div class="contract-page__change-note">
            <app-input
              id="client-contract-template-change-note"
              label="O que mudou nesta versão"
              placeholder="Ex.: ajuste na cláusula de exclusividade (aparece no histórico)"
              [formControl]="changeNoteControl"
              [maxLength]="500" />
          </div>
        }

        <app-rich-text-editor
          [formControl]="bodyControl"
          [variables]="variables()"
          [readonly]="readOnly()" />
      </div>
    </section>

    @if (historyOpen()) {
      <div class="contract-page__aside">
        <app-partner-contract-template-history
          [versions]="versions()"
          [selectedId]="viewing()?.id ?? null"
          [loading]="versionsLoading()"
          (selectVersion)="openVersion($event)"
          (collapse)="toggleHistory()" />
      </div>
    }
  </div>
}
